import {makeAutoObservable} from "mobx"
import ValuesCompareApi from "../../api/ValuesCompareApi"
import {OzonEntityOption} from "../../components/AsyncEntitySelection"
import DictionaryApi from "../../api/DictionaryApi"
import {selectStyler} from "../../components/SelectStyler"

export default class EntityCompare {
    set value_pair_id(value: number | undefined) {
        this._value_pair_id = value;
    }

    get value_pair_id() : number | undefined {
        return this._value_pair_id;
    }

    get defaultOptions(): false | OzonEntityOption[] {
        return this._defaultOptions
    }

    set defaultOptions(value: false | OzonEntityOption[]) {
        this._defaultOptions = value
    }

    feature_type: string
    feature_value_id: number
    feature_value: string
    dictionary_id: number | undefined
    value: string | undefined
    private _attribute_id: number
    private _category_id: number
    private _defaultOptions: false | OzonEntityOption[] = false

    constructor(feature_value_id: number, feature_value: string, attribute_id: number, category_id: number, feature_type: string) {
        this._attribute_id = attribute_id
        this._category_id = category_id
        this.feature_value_id = feature_value_id
        this.feature_value = feature_value
        this.feature_type = feature_type
        makeAutoObservable(this)
    }

    private _value_pair_id: number | undefined
    private _defaultOption: { value: string; label: string } | undefined

    get defaultOption(): { value: string; label: string } | undefined {
        return this._defaultOption
    }

    setAndSave(value: string, dictionary_id: string) {
        this.dictionary_id = +dictionary_id
        this.value = value

        // ValuesCompareApi.savePair({
        //     id: this._value_pair_id,
        //     feature_value_id: this.feature_value_id,
        //     dictionary_id: dictionary_id,
        //     feature_value_type: this.feature_type,
        //     ozon_attribute_id: this._attribute_id,
        //     ozon_category_id: this._category_id
        // }).then((result) => {
        //     this._value_pair_id = parseInt(result.data.data)
        // })
    }

    delete() {
        if (this._value_pair_id) {
            this.dictionary_id = -1
            // ValuesCompareApi.deletePairWith(this._value_pair_id)
            //     .then((result) => {
            //         console.log(result)
            //     })
        }
    }

    setDefaultOption(option: { value: string, label: string }) {
        this._defaultOption = option
    }

    getOptions = (inputValue: string): Promise<ReadonlyArray<OzonEntityOption>> => {
        // if(inputValue) selectStyler.noOptionsMessage = () => "Варианты не найдены"
        return DictionaryApi.getAttributeDictionary({query: inputValue, attribute_id: this._attribute_id, category_id: this._category_id})
            .then((result) => {
                const data = result.data.data
                const options = []
                for (const datum of data) {
                    options.push({
                        label: datum.value,
                        value: datum.value_id
                    })
                }
                return options
            })
    }

    getDefaultOptions = () => {
        return this.getOptions("").then((result) => {
            this.defaultOptions = [...result]
            this.defaultOptions.length > 0 ? (selectStyler.noOptionsMessage = () => "Варианты не найдены") : (selectStyler.noOptionsMessage = () => "Загрузите значения Озон")
        })
    }
}